import { DotsSixVertical } from '@phosphor-icons/react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import React, { useState } from 'react'
import { webContentStore } from 'state/setting/webContent'
import '../styles/reorder-modal.scss'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { result } from 'lodash'
import { useReorderSlides } from 'api/Settings/WebContent'
import { myStore } from 'state/store'

const ReorderModal: React.FC = () => {
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const [updatedOrder, setUpadtedOrder] = useState([])
  const { reorderSlidesModal, setReorderSlidesModal, slides } = webContentStore(
    store => ({
      reorderSlidesModal: store.reorderSlidesModal,
      setReorderSlidesModal: store.setReorderSlidesModal,
      slides: store.slides,
    }),
  )

  const { mutate: reorderSliderMutation } = useReorderSlides()

  const onDragEnd = (result: any) => {
    if (!result.destination) {
      return
    }

    const [reorderedItem] = slides.splice(result.source.index, 1)
    slides.splice(result.destination.index, 0, reorderedItem)

    const updatedSlides = slides.map((slide, index) => ({
      ...slide,
      order: index + 1,
    }))

    setUpadtedOrder(
      updatedSlides.map(slide => {
        return {
          carouselContentId: slide.id,
          order: slide.order,
        }
      }),
    )
  }

  const handleSubmit = () => {
    const payload = {
      carousels: updatedOrder,
    }
    setModalBtnLoader(true)
    reorderSliderMutation(payload, {
      onSuccess: () => {
        setModalBtnLoader(false)
        setReorderSlidesModal(false)
      },
      onError: () => {
        setModalBtnLoader(false)
      },
    })
  }

  return (
    <CustomModal
      openModal={reorderSlidesModal}
      closeModal={setReorderSlidesModal}
      title="Reorder sections"
      footer={
        <CustomModalFooter
          multibutton={false}
          btnAlignment="justify-end"
          btnText="Save new order"
          onSubmit={handleSubmit}
        />
      }
    >
      <p>
        Drag and reorder sections in the order you want them to appear in hero
        sections.
      </p>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="admissionTickets">
          {provided => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {slides.length > 0 &&
                slides.map((slide, index: number) => (
                  <Draggable
                    key={slide.id}
                    draggableId={slide.id}
                    index={index}
                  >
                    {provided => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className="drag-container">
                          <DotsSixVertical size={20} color="#000" />
                          <p
                            className="text-16 w-600"
                            dangerouslySetInnerHTML={{
                              __html: slide.content.heading?.replace(
                                /^<p>|<\/p>$/g,
                                '',
                              ),
                            }}
                          ></p>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </CustomModal>
  )
}

export default ReorderModal
